import { connect } from 'react-redux'
import { get } from 'lodash'

import CardReaderIndicator from '../components/CardReaderIndicator'

const mapStateToProps = (state) => {
  const available = state?.peripheral?.peripheralStatus === 'ready'

  return { available }
}

export default connect(mapStateToProps, undefined)(CardReaderIndicator)
